import React from "react";

// Global error boundary: prevents a blank white screen if any component throws.
// Shows a readable message + reload action instead of an empty page.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Something went wrong" };
  }

  componentDidCatch(error, info) {
    // Log so it shows up in the browser console for debugging
    console.error("App crashed:", error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false, message: "" });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="app-error-boundary"
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "16px",
            padding: "24px",
            textAlign: "center",
            background: "#0A0F1C",
            color: "#fff",
            fontFamily: "system-ui, sans-serif",
          }}
        >
          <h1 style={{ fontSize: "22px", fontWeight: 700 }}>Kuch galat ho gaya</h1>
          <p style={{ color: "#94a3b8", maxWidth: "420px" }}>
            Page load karne mein dikkat aayi. Please refresh karein. Agar problem
            bani rahe to support se sampark karein.
          </p>
          <button
            onClick={this.handleReload}
            data-testid="error-reload-btn"
            style={{
              background: "linear-gradient(90deg,#06b6d4,#8b5cf6)",
              color: "#fff",
              border: "none",
              borderRadius: "9999px",
              padding: "10px 24px",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Refresh / Dobara Try Karein
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
